/**
 * Also fix for the absent console in IE9
 */
if (!window.console) {
  window.console = {};

  window.console.log = window.console.assert = function () {};

  window.console.warn = window.console.assert = function () {};
}